import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { UserCheck, Activity, Shield, Award, MapPin, Check, TrendingUp } from 'lucide-react';
const features = [{
  icon: UserCheck,
  title: 'Atención personalizada',
  description: 'Cada piel y cada persona son diferentes. Evaluamos tus necesidades para diseñar un tratamiento adaptado a tus objetivos y características específicas.'
}, {
  icon: Activity,
  title: 'Seguimiento en cada etapa',
  description: 'Acompañamos tu evolución sesión tras sesión para asegurar resultados progresivos y resolver cualquier duda durante el proceso.'
}, {
  icon: Shield,
  title: 'Seguridad y confianza',
  description: 'Trabajamos bajo protocolos profesionales enfocados en el cuidado de tu piel, priorizando siempre tu bienestar, comodidad y tranquilidad.'
}, {
  icon: Award,
  title: 'Tecnología Láser Soprano homologada por MSP',
  description: 'Utilizamos tecnología certificada, reconocida por su eficacia, seguridad y comodidad en distintos tipos de piel, permitiendo tratamientos más confortables y efectivos.'
}, {
  icon: MapPin,
  title: 'Atención en Cordón, Montevideo',
  description: 'Un espacio moderno y profesional donde recibirás una atención cercana, personalizada y enfocada en lograr los mejores resultados.'
}, {
  icon: TrendingUp,
  title: 'Resultados visibles y duraderos',
  description: 'Nuestro objetivo es ayudarte a lograr una reducción progresiva y efectiva del vello. Con constancia y el plan adecuado para tu piel, podrás disfrutar de una piel más suave y menos preocupaciones a largo plazo.'
}];
const highlights = ['Tratamientos para mujeres y hombres', 'Tecnología homologada por MSP', 'Resultados visibles desde las primeras sesiones', 'Atención profesional y seguimiento continuo'];
export const Differentiators = () => {
  return <section className="py-12 sm:py-20 bg-white" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-112">
          <h2 className="text-2xl sm:text-3xl font-bold text-navy-900 mb-4" data-id="element-113">
            ¿Por qué elegir Depilación Láser Uruguay?
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-114">
            Nos enfocamos en brindarte una experiencia cómoda, segura y
            profesional, con tecnología avanzada y resultados visibles desde las
            primeras sesiones.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-115">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-100 hover:shadow-lg transition-shadow" data-id="element-116">
              <div className="w-14 h-14 bg-brand-100 rounded-xl flex items-center justify-center mb-6 text-brand-600" data-id="element-117">
                <feature.icon className="w-7 h-7" data-id="element-118" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-119">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-120">
                {feature.description}
              </p>
            </motion.div>)}
        </div>

        <motion.ul initial="hidden" whileInView="show" viewport={{
        once: true
      }} variants={{
        hidden: {},
        show: {
          transition: {
            staggerChildren: 0.12
          }
        }
      }} className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 bg-navy-900 rounded-2xl p-6 sm:p-8" data-id="element-121">
          {highlights.map((item, i) => <motion.li key={item} variants={{
          hidden: {
            opacity: 0,
            x: -16
          },
          show: {
            opacity: 1,
            x: 0
          }
        }} transition={{
          duration: 0.45,
          ease: 'easeOut'
        }} whileHover={{
          x: 4
        }} className="group flex items-center gap-3 text-white rounded-xl px-3 py-2 hover:bg-white/5 transition-colors cursor-default" data-id="element-122">
              <motion.span animate={{
            boxShadow: ['0 0 0 0 rgba(58,107,165,0)', '0 0 16px 2px rgba(58,107,165,0.65)', '0 0 0 0 rgba(58,107,165,0)']
          }} transition={{
            duration: 2.4,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: i * 0.3
          }} className="w-6 h-6 bg-brand-600 rounded-full flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-123">
                <Check className="w-4 h-4" data-id="element-124" />
              </motion.span>
              <span className="font-medium" data-id="element-125">{item}</span>
            </motion.li>)}
        </motion.ul>
      </div>
    </section>;
};